var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchTweet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1862_170648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33313 17.5013V6.66797C3.33313 6.00493 3.59652 5.36904 4.06536 4.9002C4.5342 4.43136 5.17009 4.16797 5.83313 4.16797H14.1665C14.8295 4.16797 15.4654 4.43136 15.9342 4.9002C16.4031 5.36904 16.6665 6.00493 16.6665 6.66797V11.668C16.6665 12.331 16.4031 12.9669 15.9342 13.4357C15.4654 13.9046 14.8295 14.168 14.1665 14.168H6.66646L3.33313 17.5013Z",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.16797V9.1763",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66687 9.16797V9.1763",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3331 9.16797V9.1763",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1862_170648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchTweet);
export default __webpack_public_path__ + "static/media/icon_search_tweet.c7ea66215573db1b47f0fc4355078631.svg";
export { ForwardRef as ReactComponent };